import { RawUser, UserEntity } from './Types';
import { GalleryEntity } from '../Gallery/Types';
import { GalleryModel } from '../Gallery/GalleryModel';
import { PivotEntity } from '../Pivot/Types';
import { PivotModel } from '../Pivot/PivotModel';
import { BaseModel } from '../BaseModel/BaseModel';
import { UserRoleEntity } from '../UserRole/Types';
import { UserRoleModel } from '../UserRole/UserRoleModel';

export class UserModel
    extends BaseModel<RawUser, UserEntity>
    implements UserEntity
{
    createdAt: string = new Date().toISOString();
    currentSubscription: object = {};
    email: string = '';
    emailVerifiedAt: string | null = null;
    firstName: string | null = null;
    galleries?: GalleryEntity[] = [];
    id: number = 0;
    lastName: string | null = null;
    phone: string | null = null;
    pivot?: PivotEntity;
    projectsCount: number = 0;
    roleExpiration: string | null = null;
    roleId: number = 0;
    tokens: number = 0;
    updatedAt: string = new Date().toISOString();
    username: string = '';
    role?: UserRoleEntity;

    constructor(user?: RawUser) {
        super();
        if (user) {
            this.initialize(user);
        }
    }

    initialize(user: RawUser) {
        this.createdAt = user.created_at;
        this.email = user.email;
        this.emailVerifiedAt = user.email_verified_at;
        this.firstName = user.first_name;
        this.id = user.id;
        this.lastName = user.last_name;
        this.phone = user.phone;
        this.projectsCount = user.projects_count;
        this.roleExpiration = user.role_expiration;
        this.roleId = user.role_id;
        this.tokens = user.tokens;
        this.updatedAt = user.updated_at;
        this.username = user.username;
        this.currentSubscription = user.current_subscription;
        this.galleries = user.galleries?.length
            ? user.galleries.map(gallery => new GalleryModel(gallery))
            : [];
        this.pivot = user.pivot ? new PivotModel(user.pivot) : undefined;
        this.role = user.role ? new UserRoleModel(user.role) : undefined;
    }

    parse(): RawUser {
        return {
            created_at: this.createdAt,
            current_subscription: this.currentSubscription,
            email: this.email,
            email_verified_at: this.emailVerifiedAt,
            first_name: this.firstName,
            id: this.id,
            last_name: this.lastName,
            phone: this.phone,
            pivot: this.pivot ? this.pivot.parse() : undefined,
            projects_count: this.projectsCount,
            role_expiration: this.roleExpiration,
            role_id: this.roleId,
            tokens: this.tokens,
            updated_at: this.updatedAt,
            username: this.username,
            ...(this.galleries && {
                galleries: this.galleries.map(gallery => gallery.parse()),
            }),
            role: this.role ? this.role.parse() : undefined,
        };
    }
}
